var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('layout-nav'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('layout-footer'),_vm._v(" "),_c('layout-aside')],1)}
var staticRenderFns = []

export { render, staticRenderFns }